import { useSelector } from "react-redux"
import styled from "styled-components"
import UpdateBlog from "./UpdateContent"
import UpdateBlogNewContentSide from "./UpdateBlogNewContentSide"

const Container = styled.div`
    height: 100%;
    width: 100%;
    .border{
        border-top: 3px solid ${({theme}) => theme.mainBorderColor};
    }
    
`


const UpdateBlogContentController = ({data}) => {
    const {selectedBlog} = useSelector((state) => state.admin3)
    
  return (

    <Container>

        {selectedBlog?.mainBlogs?.length > 0 && 
            selectedBlog?.mainBlogs?.map((item) => {
                return (
                    <UpdateBlog data={item} />
                )
            })
        }
        
        {
            selectedBlog?.mainBlogs?.length > 0 && 
            <div className="border" />
        }

        <UpdateBlogNewContentSide />
        
    </Container>
  )
}

export default UpdateBlogContentController